import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Layout from "../components/Layout";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <Layout>
      <SEO title="Page Not Found | Driver Reborn Advisory" description="The page you requested could not be found." noindex={true} />
      <section className="section">
        <div className="container-tight">
          <div className="text-[#FF6A00] text-xs uppercase tracking-widest mb-2">404 — Not Found</div>
          <h1 className="font-bebas text-5xl sm:text-6xl uppercase leading-none mb-4" data-testid="notfound-title">
            This page does not exist.
          </h1>
          <p className="text-lg text-[#A1A1AA] leading-relaxed mb-8">
            The URL you entered is not part of the Driver Reborn Advisory site. Start with the free Fleet Crossroads Scorecard or return home.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/" className="btn-ghost" data-testid="notfound-home">Return Home</Link>
            <Link to="/fleet-crossroads-scorecard" className="btn-primary" data-testid="notfound-assessment">
              Take the Fleet Crossroads Scorecard <ArrowRight size={20}/>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
